import { v1ApiClient } from '@/services';
import type { Operation, Schema } from '@/shared/api/generated';

type RetrieveAggregatedReportFoldersOperation =
  Operation<'RetrieveAggregatedReportFolders'>;

export type GetAggregatedReportFolderListParams =
  RetrieveAggregatedReportFoldersOperation['parameters']['path'];

export type GetAggregatedReportFolderListResponse =
  Schema<'RetrieveAggregatedReportFoldersResponse'>;

export type AggregatedReportFolder = Schema<'AggregatedReportFolder'>;

export const getAggregatedReportFolderList = ({
  workspace_id,
}: GetAggregatedReportFolderListParams): Promise<GetAggregatedReportFolderListResponse> =>
  v1ApiClient
    .get(`/workspaces/${workspace_id}/aggregated-report-folders`)
    .then((res) => res.data);
